import htmlSanitize from 'sanitize-html';

const ALLOWED_TAGS = htmlSanitize.defaults.allowedTags.concat([
	'span',
	'font',
	'field',
	'h1',
	'h2',
	'h3',
	'img',
	'colgroup',
	'col',
	'br',
]);
const DIALOG_STYLE = 'box-sizing: border-box; z-index: 1300; position: fixed; inset: 0px;';
const ALLOWED_ATTRIBUTES_MAP = {
	a: ['href', 'target', 'rel'],
	span: ['style', 'datatype', 'data-id', 'class', 'data-entity'],
	i: ['style', 'class'],
	div: ['class', 'style', 'data-pasted-html'],
	img: ['alt', 'style', 'width', 'height', 'data-link'],
	table: [
		'width',
		'class',
		'cellpadding',
		'cellspacing',
		'dir',
		'border',
		'style',
		'video-beat-data',
	],
	tr: ['style', 'class', 'colspan', 'valign', 'align', 'height', 'bgcolor'],
	td: ['style', 'rowspan', 'width', 'class', 'colspan', 'valign', 'align', 'height', 'bgcolor'],
	tbody: ['style', 'class'],
	font: ['color', 'style', 'class'],
	h1: ['style', 'class'],
	p: ['style', 'class', 'align'],
	li: ['style'],
	col: ['width', 'style', 'height'],
	colgroup: ['width', 'style', 'height'],
	field: [
		'class',
		'field_name',
		'field_type',
		'format_type',
		'format_pattern',
		'q',
		'type',
		'fallback',
		'belongs_to',
		'uid',
		'account_role',
		'owner_field',
		'dimension',
		'display_type',
	],
};

const EMPTY_ARR = [];
const ID_ARR = ['id'];
const CONTETNTEDITABLE_ARR = ['id'];

const sanitizeRichTextContent = (
	dirty,
	{
		allowedTags = ALLOWED_TAGS,
		allowedAttributes = {},
		allowedClasses,
		removeImgSrc,
		removeIds,
		removeContentEditable,
	} = {},
) =>
	htmlSanitize(dirty, {
		allowedTags,
		allowedAttributes: {
			a: ALLOWED_ATTRIBUTES_MAP.a,
			span: ALLOWED_ATTRIBUTES_MAP.span.concat(
				removeContentEditable ? EMPTY_ARR : CONTETNTEDITABLE_ARR,
			),
			i: ALLOWED_ATTRIBUTES_MAP.i,
			div: ALLOWED_ATTRIBUTES_MAP.div,
			img: ALLOWED_ATTRIBUTES_MAP.img.concat(removeImgSrc ? EMPTY_ARR : ['src']),
			table: ALLOWED_ATTRIBUTES_MAP.table.concat(removeIds ? EMPTY_ARR : ID_ARR),
			tr: ALLOWED_ATTRIBUTES_MAP.tr.concat(removeIds ? EMPTY_ARR : ID_ARR),
			td: ALLOWED_ATTRIBUTES_MAP.td.concat(removeIds ? EMPTY_ARR : ID_ARR),
			tbody: ALLOWED_ATTRIBUTES_MAP.tbody.concat(removeIds ? EMPTY_ARR : ID_ARR),
			font: ALLOWED_ATTRIBUTES_MAP.font,
			h1: ALLOWED_ATTRIBUTES_MAP.h1,
			p: ALLOWED_ATTRIBUTES_MAP.p,
			li: ALLOWED_ATTRIBUTES_MAP.li,
			col: ALLOWED_ATTRIBUTES_MAP.col,
			colgroup: ALLOWED_ATTRIBUTES_MAP.colgroup,
			field: ALLOWED_ATTRIBUTES_MAP.field.concat(
				removeContentEditable ? EMPTY_ARR : CONTETNTEDITABLE_ARR,
			),
			...allowedAttributes,
		},
		...(allowedClasses && { allowedClasses }),
		// Remove all tags with style attribute that contains dialog style
		exclusiveFilter: frame => frame.tag === 'div' && frame?.attribs?.style?.includes(DIALOG_STYLE),
	});

const sanitizeXss = html =>
	htmlSanitize(html, {
		allowedTags: false, // allows all tags
		allowedAttributes: false, // allows all attributes
		transformTags: {
			img: (tagName, { onerror, ...attribs }) => ({
				tagName,
				attribs,
			}),
		},
	});

const sanitizeString = string =>
	htmlSanitize(string, {
		allowedTags: [],
		allowedAttributes: {},
	});

const unSanitizeString = string => {
	if (!string) {
		return '';
	}

	const parser = new DOMParser();

	return parser.parseFromString(string, 'text/html').body.textContent ?? '';
};

export { sanitizeRichTextContent, sanitizeXss, sanitizeString, ALLOWED_TAGS, unSanitizeString };
